import http from '@/plugins/api'
import * as types from './types'
import {
  startLoading
} from '@/plugins/loading'

const authUrl = window.config ? window.config.authUrl : ''
const src = window.config ? window.config.source : 'astechwebaportal'
// a helper method to collect vee validation child components
function collectChildValidation($this, validations) {
  $this.$children.forEach(vm => {
    validations.push(vm.$validator.validateAll())
    if (vm.$children.length) {
      collectChildValidation(vm, validations)
    }
  })
}

export default {
  clearToken({
    commit,
    state
  }) {
    commit(types.RESET_LOGIN)
  },
  setPassthrough({
    commit
  }, passthrough) {
    commit(types.SET_PASSTHROUGH, passthrough)
  },
  async getToken({
    commit,
    getters,
    dispatch
  }, [user, pwd]) {
    const t = await startLoading(dispatch, 'getToken', () =>
      http.post('getToken', {
        user,
        pwd,
        src
      }, {}, authUrl)
    )
    commit(types.SET_TOKEN, t.data)
    if (getters.user && getters.user.prn) {
      const r = await startLoading(dispatch, 'getToken', () =>
        http.get('user/getUserByName', {
          params: {
            username: user
          }
        })
      )
      // console.log(r.data, r.data[0])
      commit(types.SET_ROLES, r.data[0])
    }
  },
  veeValidateAll({
    commit
  }, $this) {
    return new Promise((resolve, reject) => {
      let validations = [$this.$validator.validateAll()]
      collectChildValidation($this, validations)
      Promise.all(validations)
        .then(r => resolve(r.every(i => i === true)))
        .catch(reject)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js